<template>
  <div class="financial-statements-hk">
    <components
      :is="currentStatement"
      :data="tableData"
      :reportKindMap="reportKindMap"
      :css="css"
      :formatAParams="formatAParams"
      :mainDataStyle="mainDataStyle"
    ></components>
  </div>
</template>

<script>
import IncomeStatement0 from './IncomeStatement-0.vue'
import IncomeStatement1 from './IncomeStatement-1.vue'
import IncomeStatement2 from './IncomeStatement-2.vue'
const statementComponents = {
  0: IncomeStatement0,
  1: IncomeStatement1,
  2: IncomeStatement2,
  3: IncomeStatement0
}
export default {
  props: ['css', 'mainDataStyle'],
  data() {
    return {
      tableData: [],
      reportKindMap: {
        0: '非金融',
        1: '银行',
        2: '保险',
        3: '非金融'
      }
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    reportKind() {
      return this.tableData[0]?.reportKind
    },
    currentStatement() {
      return statementComponents[this.reportKind]
    }
  },
  created() {
    this.getIncomeStatement()
  },
  methods: {
    // 将A股同义字段统一为港股接口字段名称
    formatAParams(val) {
      if (this.market !== 'hs') return val

      const oldVal = val.replace('YoY', '')

      const newVal = {
        /* 非金融 */
        // 营业成本
        operatingExpenses: 'operatingCost',
        // 行政开支
        generalAdminExpenses: '',
        // 其他营业支出
        otherOperatingExpenses: 'otherOperCost',
        // 经营开支总额
        totalOperatingExpenses: 'totalOperCost',
        // 核心溢利
        coreProfit: '',
        // 其它非经营项目 TODO 不确定
        otherNonOperatingItems: 'otherIncome',
        // 营业利润
        operatingProfit: 'operProfit',
        // 财务成本
        financeCost: 'finaCost',
        // 共同控制公司及联营公司
        joinContrEntitiesAssociates: '',
        // 除税前溢利
        profitBeforeTaxation: '',
        // 税项
        taxation: 'incomeTaxExpense',
        // 本期间溢利
        profitThePeriod: '',
        // 本公司股本持有人应占
        ownersOfTheCom: '',
        // 非控股权益
        nonControllingInterests: '',
        // 其他全面收入
        otherComprehensiveIncome: 'otherCompreIncome',
        // 全面收入总额
        totalComprehensiveIncome: 'totalConIncome',
        // 物业、机器及设备折旧
        depreciation: '',
        // 折旧及摊销
        depreciationAmortization: '',
        // 普通股股息
        commonShareDividend: '',
        // 税率
        taxationRate: '',

        /* 银行 不包含上方已出现的字段 */
        // 利息收益净额
        netInterestIncome: 'interestNetIncome',
        // 费用收益 TODO 不确定
        feeIncome: 'commissionIncome',
        // 费用支出
        feeExpense: '',
        // 费用收益净额 TODO 不确定
        netFeeIncome: 'commissionNetIncome',
        // 交易收益净额
        netTradingIncome: '',
        // 保险收入净额
        netEarnedInsurancePermiums: '',
        // 其他营业收益
        otherOperatingIncome: 'otherOperRevenue',
        // 保险索赔净额
        netEarnedInsuranceIncurred: '',
        // 未扣除贷款减值及其他准备之营业收益净额
        netIncomeBeforeImpAndPro: '',
        // 贷款减值及信贷风险准备
        impairmentAndProvisions: '',
        // 营业收益净额
        netOperatingIncome: '',
        // 无形资产摊销
        amortization: '',
        // 财报每股派息
        dps: '',

        /* 保险 不包含上方已出现的字段 */
        // 毛承保费及保单费收入
        grossWrittenPremium: '',
        // 分出保费
        premiumCededToReinsurers: 'premiumToReinsurer',
        // 净承保费及保单费收入
        netWrittenPremium: '',
        // 未到期责任准备金变动
        unearnedPremiumReserves: '',
        // 已赚取保费及保费单收入净额 TODO 不确定
        netEarnedPremium: 'premiumEarned',
        // 净投资收益 TODO 不确定
        netInvestmentIncome: 'invIncome',
        // 净保费及投资收益总额
        premiumAndInvestmentIncome: '',
        // 已实现及未实现的投资收益/(亏损)
        gainsOnInvestments: '',
        // 汇兑收益/(亏损)
        netForeignExchangeGains: '',
        // 佣金支出净额
        netCommissionExpenses: '',
        // 行政及其他费用
        generalAndAdminExpenses: '',
        // 保险业务支出及其他费用
        totalBenefitsClaimsAndExpenses: ''
      }[oldVal]

      return newVal ? val.replace(oldVal, newVal) : val
    },
    // 将A股值不同的字段统一为港股接口字段值
    formatAVal(val, type = 'reportType') {
      return (
        {
          reportType: {
            12: 'F',
            9: 'Q3',
            6: 'I',
            1: 'Q1'
          },
          currency: {
            142: 'RMB'
          }
        }?.[type]?.[val] ?? val
      )
    },
    async getIncomeStatement() {
      const res = await this.$post(this.$api.f10[this.market] + '/finance/income', {
        symbol: this.symbol,
        startDate: this.$dayjs().subtract(5, 'year').format('YYYY-MM-DD')
      })
      const reportTypeMap = {
        F: 4,
        Q3: 3,
        I: 2,
        Q1: 1
      }

      let data = res.data?.filter((item) => Boolean(reportTypeMap[this.formatAVal(item.reportType)])) ?? []

      data = data.map((item) => {
        item.sortYear = +this.$dayjs(item.reportDate).format('YYYY')
        item.reportType = this.formatAVal(item.reportType)
        item.currency = this.formatAVal(item.currency, 'currency')
        return item
      })

      this.tableData = data.sort(
        (a, b) => b.sortYear - a.sortYear || reportTypeMap[b.reportType] - reportTypeMap[a.reportType]
      )
    }
  }
}
</script>

<style lang="scss">
.financial-statements-hk {
}
</style>
